import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import {
  userShape,
  institutionPermissionsShape,
} from '../../utils/propTypesShapes';

import CheckIcon from '../../assets/svgs/CheckIcon';
import DeleteIcon from '../../assets/svgs/DeleteReportIcon';
import EditIcon from '../../assets/svgs/EditReportIcon';
import Api from '../../libs/Api';

const UserListItem = ({
  userItem,
  handleDeleteUser,
  handleCatchUserDataForEdition,
  institutionPermissions,
  setUserActionComplete,
  loading,
}) => {
  const institution = useSelector((state) => state.settings.institution);

  const [user, setUser] = useState({});
  const [addExamPermission, setAddExamPermission] = useState(false);
  const [seeExamsPermission, setSeeExamsPermission] = useState(false);
  const [approveReportPermission, setApproveReportPermission] = useState(false);
  const [addExamID, setAddExamID] = useState(0);
  const [seeExamsID, setSeeExamsID] = useState(0);
  const [approveReportID, setApproveReportID] = useState(0);

  useEffect(() => {
    if (!Number.isNaN(userItem.date_joined)) {
      const dateToFormat = new Date(userItem.date_joined);
      userItem.date_joined = `${dateToFormat.getDate()}/${
        dateToFormat.getMonth() + 1
      }/${dateToFormat.getFullYear()}`;
    }

    if (userItem.type) {
      if (userItem.type === 'DOC') {
        userItem.type = 'Doctor';
      }

      if (userItem.type === 'TEC') {
        userItem.type = 'Technician';
      }
    }

    setUser(userItem);
  }, [userItem, setUserActionComplete, loading]);

  useEffect(() => {
    const currentInstitutionPermissions = [];
    institutionPermissions.forEach((institutionPermission) => {
      if (institutionPermission.institution === institution.id) {
        currentInstitutionPermissions.push(institutionPermission);
      }
    });

    currentInstitutionPermissions?.forEach((institutionPermission) => {
      if (institutionPermission.permission === 'add_exams') {
        setAddExamID(institutionPermission.id);
      }

      if (institutionPermission.permission === 'see_results') {
        setSeeExamsID(institutionPermission.id);
      }

      if (institutionPermission.permission === 'approve_report') {
        setApproveReportID(institutionPermission.id);
      }

      if (userItem?.permissions?.includes(institutionPermission.id)) {
        if (institutionPermission.permission === 'add_exams') {
          setAddExamPermission(true);
        }

        if (institutionPermission.permission === 'see_results') {
          setSeeExamsPermission(true);
        }

        if (institutionPermission.permission === 'approve_report') {
          setApproveReportPermission(true);
        }
      }
    });
  }, [userItem, institutionPermissions, institution]);

  const updateUserPermission = (permissionName) => {
    const updateUserPermissionRequest = {};

    if (permissionName === 'add_exams') {
      setAddExamPermission(!addExamPermission);
      updateUserPermissionRequest.permission = addExamID;
      updateUserPermissionRequest.active = !addExamPermission;
    }

    if (permissionName === 'see_results') {
      setSeeExamsPermission(!seeExamsPermission);
      updateUserPermissionRequest.permission = seeExamsID;

      updateUserPermissionRequest.active = !seeExamsPermission;
    }

    if (permissionName === 'approve_report') {
      setApproveReportPermission(!approveReportPermission);
      updateUserPermissionRequest.permission = approveReportID;
      updateUserPermissionRequest.active = !approveReportPermission;
    }

    // const permissionId = institutionPermissions.filter(
    //   (elemento) => elemento.permission === permissionName
    // );

    updateUserPermissionRequest.user = userItem?.id;
    // updateUserPermissionRequest.permission = permissionId?.[0]?.id;

    Api.postUpdateUserPermission(updateUserPermissionRequest).then(
      (response) => {
        if (response.status === 200) {
          setUserActionComplete({
            type: 'success',
            text: 'Permissão alterada com sucesso',
          });
        }
        if (response.status === 400) {
          setUserActionComplete({
            type: 'error',
            text: 'Não foi possível alterar a permissão',
          });
        }
        if (response.status === 403) {
          setUserActionComplete({
            type: 'error',
            text: 'Não foi possível alterar a permissão',
          });
        }
      }
    );
  };

  return (
    <ul className="users-list-data">
      <div className="user-list-item">
        <div className="name-list-item user-list-item-data">
          <span>{user.name}</span>
        </div>
        <div className="matriculation-list-item user-list-item-data">
          <span>{user.inscription}</span>
        </div>
        <div className="role-list-item user-list-item-data">
          <span>{user.type}</span>
        </div>
        <div className="registration-date-list-item user-list-item-data">
          <span>{user.date_joined}</span>
        </div>
        <div className="patient-data-list-item user-list-item-data">
          <div className="option-container">
            <button
              type="button"
              className="check-box"
              onClick={() => updateUserPermission('add_exams')}
            >
              <span className="box">
                {addExamPermission ? <CheckIcon /> : null}
              </span>
            </button>
          </div>
        </div>
        <div className="images-exams-list-item user-list-item-data">
          <div className="option-container">
            <button
              type="button"
              className="check-box"
              onClick={() => updateUserPermission('see_results')}
            >
              <span className="box">
                {seeExamsPermission ? <CheckIcon /> : null}
              </span>
            </button>
          </div>
        </div>
        <div className="report-results-list-item user-list-item-data">
          <div className="option-container">
            <button
              type="button"
              className="check-box"
              onClick={() => updateUserPermission('approve_report')}
            >
              <span className="box">
                {approveReportPermission ? <CheckIcon /> : null}
              </span>
            </button>
          </div>
        </div>
        <div className="actions-list-item user-list-item-data">
          <div className="actions-item">
            <button
              type="button"
              onClick={() => handleCatchUserDataForEdition(user.id)}
            >
              <EditIcon />{' '}
            </button>
            <button type="button" onClick={() => handleDeleteUser(user.id)}>
              <DeleteIcon />
            </button>
          </div>
        </div>
        <div className="go-to-user-text">see more</div>
      </div>
    </ul>
  );
};

UserListItem.propTypes = {
  userItem: userShape,
  handleDeleteUser: PropTypes.func.isRequired,
  handleCatchUserDataForEdition: PropTypes.func.isRequired,
  institutionPermissions: PropTypes.arrayOf(institutionPermissionsShape)
    .isRequired,
  setUserActionComplete: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

UserListItem.defaultProps = {
  userItem: [],
};

export default UserListItem;
